var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackProactivityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 124,
    viewBox: "0 0 118 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6782 70.9933L41.1398 70.7083C38.9548 69.6 37.1498 67.795 36.0415 65.61L35.7565 65.0717C34.6482 62.9183 31.6082 62.9183 30.4998 65.0717L30.2148 65.61C29.1065 67.795 27.3015 69.6 25.1165 70.7083L24.5782 70.9933C22.4248 72.1017 22.4248 75.1417 24.5782 76.25L25.1165 76.535C27.3015 77.6433 29.1065 79.4483 30.2148 81.6333L30.4998 82.1717C31.6082 84.325 34.6482 84.325 35.7565 82.1717L36.0415 81.6333C37.1498 79.4483 38.9548 77.6433 41.1398 76.535L41.6782 76.25C43.8315 75.1417 43.8315 72.1017 41.6782 70.9933Z",
    fill: "url(#paint0_linear_8945_454)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1365 56.7117L55.6432 55.6983C57.2582 52.5317 59.7915 49.9983 62.9582 48.3833L63.9715 47.8767C67.3915 46.135 69.5132 42.6517 69.5132 38.82C69.5132 34.9883 67.3915 31.505 63.9715 29.7317L62.9582 29.225C59.7915 27.61 57.2582 25.0767 55.6432 21.91L55.1365 20.8967C53.3948 17.4767 49.9115 15.355 46.0798 15.355C42.2482 15.355 38.7648 17.4767 36.9915 20.8967L36.4848 21.91C34.8698 25.0767 32.3365 27.61 29.1698 29.225L28.1565 29.7317C24.7365 31.4733 22.6148 34.9567 22.6148 38.82C22.6148 42.6833 24.7365 46.135 28.1565 47.9083L29.1698 48.415C32.3365 50.03 34.8698 52.5633 36.4848 55.73L36.9915 56.7433C38.7332 60.1633 42.2165 62.285 46.0798 62.285C49.9432 62.285 53.3948 60.1633 55.1682 56.7433L55.1365 56.7117ZM47.1882 51.3917L46.6815 52.405C46.6815 52.405 46.4915 52.785 46.0798 52.785C45.6682 52.785 45.5098 52.5 45.4782 52.405L44.9715 51.3917C42.4382 46.42 38.4798 42.4617 33.5082 39.9283L32.4948 39.4217C32.4948 39.4217 32.1148 39.2317 32.1148 38.82C32.1148 38.4083 32.3998 38.25 32.4948 38.2183L33.5082 37.7117C38.4798 35.1783 42.4382 31.22 44.9715 26.2483L45.4782 25.235C45.4782 25.235 45.6682 24.855 46.0798 24.855C46.4915 24.855 46.6498 25.1083 46.6815 25.235L47.1882 26.2483C49.7215 31.22 53.6798 35.1783 58.6515 37.7117L59.6648 38.2183C59.6648 38.2183 60.0448 38.4083 60.0448 38.82C60.0448 39.2317 59.7598 39.39 59.6648 39.4217L58.6515 39.9283C53.6798 42.4617 49.7215 46.42 47.1882 51.3917Z",
    fill: "url(#paint1_linear_8945_454)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6782 94.205L41.1398 93.92C38.9548 92.8117 37.1498 91.0067 36.0415 88.8217L35.7565 88.2833C34.6482 86.13 31.6082 86.13 30.4998 88.2833L30.2148 88.8217C29.1065 91.0067 27.3015 92.8117 25.1165 93.92L24.5782 94.205C22.4248 95.3133 22.4248 98.3533 24.5782 99.4617L25.1165 99.7467C27.3015 100.855 29.1065 102.66 30.2148 104.845L30.4998 105.383C31.6082 107.537 34.6482 107.537 35.7565 105.383L36.0415 104.845C37.1498 102.66 38.9548 100.855 41.1398 99.7467L41.6782 99.4617C43.8315 98.3533 43.8315 95.3133 41.6782 94.205Z",
    fill: "url(#paint2_linear_8945_454)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4998 68.8717H52.6665C50.0382 68.8717 47.9165 70.9933 47.9165 73.6217C47.9165 76.25 50.0382 78.3717 52.6665 78.3717H87.4998C90.1282 78.3717 92.2498 76.25 92.2498 73.6217C92.2498 70.9933 90.1282 68.8717 87.4998 68.8717Z",
    fill: "url(#paint3_linear_8945_454)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4998 92.0833H52.6665C50.0382 92.0833 47.9165 94.205 47.9165 96.8333C47.9165 99.4617 50.0382 101.583 52.6665 101.583H87.4998C90.1282 101.583 92.2498 99.4617 92.2498 96.8333C92.2498 94.205 90.1282 92.0833 87.4998 92.0833Z",
    fill: "url(#paint4_linear_8945_454)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4998 45.6283H77.9998C75.3715 45.6283 73.2498 47.75 73.2498 50.3783C73.2498 53.0067 75.3715 55.1283 77.9998 55.1283H87.4998C90.1282 55.1283 92.2498 53.0067 92.2498 50.3783C92.2498 47.75 90.1282 45.6283 87.4998 45.6283Z",
    fill: "url(#paint5_linear_8945_454)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4998 22.4167H77.9998C75.3715 22.4167 73.2498 24.5383 73.2498 27.1667C73.2498 29.795 75.3715 31.9167 77.9998 31.9167H87.4998C90.1282 31.9167 92.2498 29.795 92.2498 27.1667C92.2498 24.5383 90.1282 22.4167 87.4998 22.4167Z",
    fill: "url(#paint6_linear_8945_454)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1665 0.25H36.8332C16.7565 0.25 0.416504 16.59 0.416504 36.6667V87.3333C0.416504 107.41 16.7565 123.75 36.8332 123.75H81.1665C101.243 123.75 117.583 107.41 117.583 87.3333V36.6667C117.583 16.59 101.243 0.25 81.1665 0.25ZM108.083 87.3333C108.083 102.185 96.0182 114.25 81.1665 114.25H36.8332C21.9815 114.25 9.9165 102.185 9.9165 87.3333V36.6667C9.9165 21.815 21.9815 9.75 36.8332 9.75H81.1665C96.0182 9.75 108.083 21.815 108.083 36.6667V87.3333Z",
    fill: "url(#paint7_linear_8945_454)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8945_454",
    x1: 0.416504,
    y1: 62,
    x2: 138.118,
    y2: 61.9723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8945_454",
    x1: 0.416504,
    y1: 62,
    x2: 138.118,
    y2: 61.9723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8945_454",
    x1: 0.416504,
    y1: 62,
    x2: 138.118,
    y2: 61.9723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8945_454",
    x1: 0.416504,
    y1: 62,
    x2: 138.118,
    y2: 61.9723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8945_454",
    x1: 0.416504,
    y1: 62,
    x2: 138.118,
    y2: 61.9723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8945_454",
    x1: 0.416504,
    y1: 62,
    x2: 138.118,
    y2: 61.9723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8945_454",
    x1: 0.416504,
    y1: 62,
    x2: 138.118,
    y2: 61.9723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8945_454",
    x1: 0.416504,
    y1: 62,
    x2: 138.118,
    y2: 61.9723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackProactivityIcon);
export default __webpack_public_path__ + "static/media/black-proactivity-icon.9d0465daa171d11c4abff96829918c04.svg";
export { ForwardRef as ReactComponent };